import { BreakpointObserver } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { OpenDialogSearchMobileComponent } from 'app/components/dialog/open-dialog-search-mobile/open-dialog-search-mobile.component';
import { MainMenu } from 'app/shared/models/class/menu/menu';
import { Notice } from 'app/shared/models/class/notice/notice';
import { DataService } from 'app/shared/services/data/data.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { MenuService } from 'app/shared/services/menu/menu.service';
import { NoticeService } from 'app/shared/services/notice/notice.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';

@Component({
  selector: 'app-header-home',
  templateUrl: './header-home.component.html',
  styleUrls: ['./header-home.component.scss'],
})
export class HeaderHomeComponent extends SubscriptionBaseComponent implements OnInit, OnDestroy {

  titleHomePage: string;
  filterOffreForm: UntypedFormGroup;
  isLogin: boolean;
  tabHome: string;
  mainMenu: MainMenu[];
  innerWidth: number;
  openSearch: boolean;
  showTags: boolean;
  topLeftText = '';
  topRightText = '';
  isMobile = false;
  notices: Notice[] = [];
  currentIndex = 0;

  intervalMs = 5000; // 5s

  speed = 0.5;
  private animationId: number | null = null;
  private desktopRotationId: ReturnType<typeof globalThis.setInterval> | null = null;
  private mobileScrollPosition = 0;
  private running = true;


  @ViewChild('scrollContainer') scrollContainer!: ElementRef<HTMLDivElement>;

  constructor(
    private readonly dataService: DataService,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly cdr: ChangeDetectorRef,
    public router: Router,
    private readonly route: ActivatedRoute,
    private readonly menuService: MenuService,
    private readonly dialog: MatDialog,
    private readonly faIconService: FaiconService,
    private readonly noticeService: NoticeService,
    private readonly mediaObserver: MediaObserver,
    private readonly breakpointObserver: BreakpointObserver,

  ) {
    super();
  }

  ngOnInit(): void {
    this.syncMobileState();
    this.initComponent();
    this.initSub();
    this.initForm();
  }

  ngOnDestroy(): void {
    this.stopRotation();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }


  getRouteNavigate(url: string) {
    if (url === '/home') {
      const urlInSessionStorage = sessionStorage.getItem('route');
      sessionStorage.getItem('route') ? this.router.navigateByUrl(urlInSessionStorage) : this.router.navigate([url]);

    } else {
      this.router.navigate([url]);
    }

  }

  ifRouteActive(url: string): boolean {
    const { structure, universe } = this.route.snapshot.queryParams;
    return url === this.router.url || (url === '/home' && !!(structure || universe));
  }

  openSearchDiv(): void {
    this.dialog.open(OpenDialogSearchMobileComponent, {
      width: '100%',
      height: '85%',
      disableClose: true
    });
  }

  seeDetails(notice: Notice): void {
    this.noticeService.detailsImage$.next({ bool: true, notice: notice });
  }

  pauseScroll(): void {
    this.running = false;
  }

  resumeScroll(): void {
    this.running = true;
  }

  private startScrollLoop(notices: Notice[]): void {
    if (notices.length <= 1 || !this.isMobile) return;

    const container = this.scrollContainer?.nativeElement;
    if (!container) return;

    this.stopRotation();
    this.mobileScrollPosition = container.scrollLeft;

    let lastTime = 0;
    const step = (currentTime: number) => {
      if (!this.running) {
        lastTime = currentTime;
        this.animationId = requestAnimationFrame(step);
        return;
      }

      // Calculer le delta time pour un défilement fluide indépendant du framerate
      const deltaTime = lastTime ? (currentTime - lastTime) / 16.67 : 1; // Normaliser à 60fps
      lastTime = currentTime;

      // Calculer dynamiquement la largeur d'une séquence (1/3 du total avec 3 duplications)
      const oneSequenceWidth = container.scrollWidth / 3;

      if (!oneSequenceWidth || oneSequenceWidth <= container.clientWidth) {
        this.animationId = requestAnimationFrame(step);
        return;
      }

      // Incrémenter le scroll de manière fluide de gauche à droite
      this.mobileScrollPosition += this.speed * deltaTime;

      // Reset transparent : quand on a parcouru une séquence complète, revenir au début
      // Le contenu étant dupliqué 3 fois, le reset est invisible
      if (this.mobileScrollPosition >= oneSequenceWidth) {
        this.mobileScrollPosition = this.mobileScrollPosition - oneSequenceWidth;
      }

      container.scrollLeft = Math.round(this.mobileScrollPosition);

      this.animationId = requestAnimationFrame(step);
    };

    this.animationId = requestAnimationFrame(step);
  }

  private startRotation(notices: Notice[]): void {
    if (this.isMobile) {
      this.startScrollLoop(notices);
    } else if (notices.length > 0) {
      this.stopRotation();
      this.desktopRotationId = globalThis.setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % notices.length;
        if (this.currentIndex === notices.length) {
          this.currentIndex = 0;
        }
      }, this.intervalMs);
    }
  }

  private stopRotation(): void {
    if (this.animationId !== null) {
      cancelAnimationFrame(this.animationId);
      this.animationId = null;
    }

    if (this.desktopRotationId !== null) {
      clearInterval(this.desktopRotationId);
      this.desktopRotationId = null;
    }
  }

  private checkThumbImageValue(notice: Notice): Notice {
    if (notice.thumbImage.startsWith('<img src="<img') && notice.thumbImage.endsWith('>">')) {
      const thumbImageFilter = notice.thumbImage.replace(/^<img src="/, '').replace(/">$/, '');
      notice.thumbImage = thumbImageFilter;
    }
    return notice;
  }

  private initComponent(): void {
    this.mainMenu = this.menuService.mainMenu;
    this.innerWidth = window.innerWidth;
    this.noticeService.getTopNotices().subscribe({
      next: datas => {
        this.topLeftText = datas.find(d => d.block === 'top_left')?.content;
        this.topRightText = datas.find(d => d.block === 'top_right')?.content;

        this.noticeService.getNotices().subscribe({
          next: notices => {
            this.notices = notices.filter(n => n.thumbImage);
            this.notices.forEach(notice => {
              this.checkThumbImageValue(notice);
            });

            this.cdr.detectChanges();
            setTimeout(() => {
              this.startRotation(this.notices);
            });
          }
        });
      }
    });
  }

  private syncMobileState(): void {
    this.isMobile = this.breakpointObserver.isMatched('(max-width: 600px)');
  }

  private initForm(): void {
    this.filterOffreForm = this.formBuilder.group({
      city: [''],
      start_date: [''],
      end_date: ['']
    });
  }

  private initSub(): void {
    this.subscription
    .add(
      this.dataService.titleHomePage.asObservable().subscribe({
        next: (titleHomePage) => { this.titleHomePage = titleHomePage; this.cdr.detectChanges(); }
      })
    )
    .add(
      this.dataService.openSearchOffer$.subscribe({
        next: openSearch => {
          this.openSearch = openSearch;
          this.cdr.detectChanges();
        }
      })
    )
    .add(
      this.dataService.showTagSearch$.subscribe({
        next: showTags => {
          this.showTags = showTags;
          this.cdr.detectChanges();
        }
      })
    )
    .add(
      this.mediaObserver.asObservable().subscribe(() => {
        const wasMobile = this.isMobile;
        this.syncMobileState();

        // Redémarrer la boucle de scroll quand le changement de breakpoint se produit
        if (wasMobile !== this.isMobile && this.notices.length > 0) {
          this.cdr.detectChanges();
          setTimeout(() => {
            this.mobileScrollPosition = 0;
            this.startRotation(this.notices);
          });
        }
      })
    );
  }

}
